import { useQuery } from '@tanstack/react-query';

import { permissionsService } from '@/services/permissions.service';
import { permissionsKeys } from './permissionsKeys';

/** Effective catalog permissions for the logged-in subject, in its acting tenant. */
export function useEffectivePermissionsQuery(
    enabled: boolean,
    userId?: string,
    tenantId?: string | null
) {
    return useQuery({
        queryKey: permissionsKeys.effective(userId, tenantId),
        queryFn: async () => {
            const data = await permissionsService.getEffectivePermissions();
            return { effectivePermissions: data.effective_permissions, source: data.source };
        },
        enabled,
    });
}

/** Screen access route rules (falls back to the static SCREEN_ROUTE_RULES if unset). */
export function useScreenRulesQuery(enabled: boolean, userId?: string) {
    return useQuery({
        queryKey: permissionsKeys.screenRules(userId),
        queryFn: async () => (await permissionsService.getScreenRules()).rules,
        enabled,
    });
}
